import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface GBDOLineageModalProps {
  open: boolean;
  onClose: () => void;
  onSelectMarket: (market: string) => void;
}

const MARKETS = [
  { label: 'BENELUX', code: 'BENELUX' },
  { label: 'FRANCE', code: 'FRANCE' },
];

export const GBDOLineageModal: React.FC<GBDOLineageModalProps> = ({
  open,
  onClose,
  onSelectMarket,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '4px',
          backgroundColor: 'rgba(245, 248, 252, 1)',
        },
      }}
    >
      <DialogTitle
        sx={{
          p: '20px 30px !important',
          backgroundColor: '#003771 !important',
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography sx={{ fontWeight: 600, color: 'white', fontSize: '20px' }}>
            Select Market for GDO Lineage
          </Typography>
          <IconButton aria-label="Close dialog" onClick={onClose} sx={{ p: 0 }}>
            <CloseIcon fontSize="medium" sx={{ color: '#ffffff' }} />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ backgroundColor: 'rgba(245, 248, 252, 1)', pt: '24px !important' }}>
        <Typography
          variant="body2"
          sx={{ textAlign: 'center', color: '#71758F', mb: 3 }}
        >
          Choose a market to view its GDO dependency graph
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 3,
            py: 2,
          }}
        >
          {MARKETS.map((market) => (
            <Button
              key={market.code}
              variant="outlined"
              onClick={() => onSelectMarket(market.code)}
              sx={{
                width: 200,
                height: 100,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                borderColor: '#009BD8',
                color: '#009BD8',
                borderRadius: '4px',
                borderWidth: '2px',
                '&:hover': {
                  borderColor: '#003771',
                  backgroundColor: 'rgba(0, 155, 216, 0.05)',
                  borderWidth: '2px',
                },
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600, color: '#0F3764' }}>
                {market.label}
              </Typography>
              <Typography variant="body2" sx={{ color: '#71758F' }}>
                ({market.code})
              </Typography>
            </Button>
          ))}
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', p: 2, backgroundColor: 'rgba(245, 248, 252, 1)' }}>
        <Button
          onClick={onClose}
          sx={{
            color: '#009BD8',
            textTransform: 'none',
            fontWeight: 500,
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GBDOLineageModal;
